import { Provider } from "./provider/Provider";

const RouterService = {
  seoUrl: ({ link }) => {
    return Provider({
      link,
      methodName: "Api/Router/SeoUrl",
    });
  },
  seoUpdateUrl: ({ link, update }) => {
    return Provider({
      link,
      update,
      methodName: "Api/Router/SeoUpdateUrl",
    });
  },
  routersList: ({ link, router, start, limit, order }) => {
    return Provider({
      link,
      router,
      start,
      limit,
      order,
      methodName: "Api/Router/RoutersList",
    });
  },
  getRouterLink: (link) => {
    return Provider({
      link,
      methodName: "Api/Router/GetRouterLink",
    });
  },
  addRouterLink: ({ link, router }) => {
    return Provider({
      link,
      router,
      methodName: "Api/Router/AddRouterLink",
    });
  },
  updateRouterLink: ({ link, update }) => {
    return Provider({
      link,
      update,
      methodName: "Api/Router/UpdateRouterLink",
    });
  },
  removeRouterLink: (link) => {
    return Provider({
      link,
      methodName: "Api/Router/RemoveRouterLink",
    });
  },
};

export default RouterService;
